import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditTutorLayer from "../components/EditTutorLayer";


const ViewProfilePage = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Tutor  </h5><Breadcrumb title="Edit Tutor" /></div>

        {/* ViewProfileLayer */}
        <EditTutorLayer />


    </>
  );
};

export default ViewProfilePage; 
